import React from "react";
import { Tag, Space, Button, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

export default function SkeyenoteRolesTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  onDeleteRole,
  isRoleUser,
}) {
  const columns = [
    {
      title: "Role Name",
      dataIndex: "name",
      key: "name",
      width: isRoleUser ? "100%" : "60%",
      render: (name) => <Tag color="#2b751d">{name}</Tag>,
    },
  ];

  if (!isRoleUser) {
    columns.push({
      title: "Actions",
      key: "actions",
      width: "40%",
      render: (_, record) => (
        <Popconfirm
          title="Delete Role"
          description={
            <span>
              Are you sure you want to delete <b>{record.name}</b>?
            </span>
          }
          onConfirm={() => onDeleteRole(record.name)}
          okText="Yes"
          cancelText="No"
          okButtonProps={{ danger: true }}
        >
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            title="Delete Role"
          />
        </Popconfirm>
      ),
    });
  }

  return (
    <DataTable
      rowKey="name"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
      sticky
      pageSizeOptions={[10, 25, 50, 100]}
    />
  );
}
